module.exports = __webpack_public_path__ + "static/media/22ESCWA1.acdc49a0.jpg";